import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

export const bc = 'reports-block'

export const renderResponses = responses =>
  responses.map((response, i) => (
    <span key={i} className={`${bc}__response`}>
      {response}
    </span>
  ))

const Block = ({ reviewerType, responses, customClassName }) => {
  return (
    <div className={`${bc} ${customClassName}`}>
      <span className={`${bc}__type`}>{reviewerType}</span>
      {responses instanceof Array ? renderResponses(responses) : <span className={`${bc}__response`}>{responses}</span>}
    </div>
  )
}

Block.propTypes = {
  responses: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  reviewerType: PropTypes.oneOf(['Self', 'Direct Reports', 'Peers', 'Supervisors']).isRequired,
}

export default Block
